<i class="fa fa-spin fa-4x fa-circle-o-notch"
   style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: #42a5f5; margin: -60px 0 0 -20px ;"></i>
